'use client';

import { useState, useEffect, useCallback } from 'react';
import { adminKycApi } from '../api';
import { AdminDocumentsResponse, DocumentFilters } from '../types';

interface UseAllDocumentsReturn {
  data: AdminDocumentsResponse | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function useAllDocuments(
  tenantSlug: string,
  filters: DocumentFilters = {},
  limit: number = 50,
  offset: number = 0
): UseAllDocumentsReturn {
  const [data, setData] = useState<AdminDocumentsResponse | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetch = useCallback(async () => {
    if (!tenantSlug) return;

    setIsLoading(true);
    setError(null);
    try {
      const result = await adminKycApi.getAllDocuments(tenantSlug, filters, limit, offset);
      setData(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch documents');
    } finally {
      setIsLoading(false);
    }
  }, [tenantSlug, filters, limit, offset]);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return { data, isLoading, error, refetch: fetch };
}
